import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { COMPANIES_PATHS } from '../companies';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { Breadcrumb } from '../../../shared/breadcrumbs/breadcrumbs';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-companies-edit',
  templateUrl: './companies-edit.component.html',
  styleUrls: ['./companies-edit.component.scss'],
  standalone: false,
})
export class CompaniesEditComponent implements OnInit {
  public companiesEditBreadcrumbs: Breadcrumb[] = [
    { text: 'Компании', url: COMPANIES_PATHS.companies },
    { text: 'Редактирование компании', url: null },
  ];

  constructor(private breadcrumbsService: BreadcrumbsService) {}

  ngOnInit() {
    this.breadcrumbsService.updateBreadcrumbs(this.companiesEditBreadcrumbs);
  }
}
